import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { useQueryParams } from "src/hooks/useQueryParams";
import { IS_EMAIL_CONFIRM_KEY } from "src/components/Header/constants";
import { ModalWindowV2 } from "src/components/ModalWindowV2";
import { ModalState } from "src/hooks/useModal";
import { emailConfirmPopupTrns } from "./trns";

interface Props extends ModalState {}

export const EmailConfirmPopup: FC<Props> = ({ ...modalProps }) => {
  const { t } = useTranslation();
  const { deleteQueryParam } = useQueryParams();

  const onClose = () => {
    modalProps.closeModal();
    deleteQueryParam(IS_EMAIL_CONFIRM_KEY);
  };

  return (
    <ModalWindowV2
      {...modalProps}
      closeModal={onClose}
      className="max-w-111.5 w-full"
      isActiveCloseClickOutside={false}
      isShownCloseButton
      isActivePortal
    >
      <div className="flex flex-col gap-5 p-5 bg-white-base border border-gray-base/20 rounded-20">
        <h3 className="font-semibold text-center">
          {t(emailConfirmPopupTrns.title)}
        </h3>

        <p className="text-center text-justify">{t(emailConfirmPopupTrns.description)}</p>

        <Button variant={ButtonVariants.PRIMARY} onClick={onClose}>
          {t(emailConfirmPopupTrns.gotItButton)}
        </Button>
      </div>
    </ModalWindowV2>
  );
};
